import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';
import { Link, NavigationItem, Set } from 'src/api/contentful/contentTypes.cloverdotcom';
import { componentKey, getField } from 'src/utils/EntryUtil';
import { VerticalLinkSet } from 'src/utils/NavigationUtil';
import { ContentLink } from '../../ContentLink/ContentLink';
import { useSalesChannel } from '../../SalesChannel/SalesChannel';
import styles from './SiteFooterSection.scss';

interface SiteFooterSectionProps {
  entry: ReferencedEntry<NavigationItem | VerticalLinkSet>;
  className?: string;
  hideTitle?: boolean;
}

const SiteFooterSection: React.FC<SiteFooterSectionProps> = ({ entry, className, hideTitle = false }) => {
  const { isDisallowedByReseller } = useSalesChannel();

  if (!entry || !entry.fields) return null;

  const title = getField(entry, 'title');
  const titleLowerCase = title ? title.toLowerCase() : '';
  const sectionID = `${entry.sys.id}-footer-section`;
  const listAttributes: React.AllHTMLAttributes<HTMLUListElement> = {
    'aria-labelledby': sectionID,
  };

  const items = getField(entry as ReferencedEntry<Set<Link>>, 'items', []);

  return (
    <nav className={cx(styles.footerSection, className)}>
      {!hideTitle && title && (
        <h5
          data-test={`footer-section-${titleLowerCase}`}
          id={sectionID}
          className={styles.title}
        >
          {title}
        </h5>
      )}
      {items.length && (
        <ul role="list" {...listAttributes}>
          {items.map((link, index) => link && !isDisallowedByReseller(link) && (
            <li key={componentKey(link, index)} className={styles.link}>
              <ContentLink
                dataTestPrefix={'footer'}
                entry={link}
              />
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export { SiteFooterSection };
